import { render, staticRenderFns } from "./invite-earn-tnc.vue?vue&type=template&id=7fd04841&scoped=true&"
import script from "./invite-earn-tnc.vue?vue&type=script&lang=js&"
export * from "./invite-earn-tnc.vue?vue&type=script&lang=js&"
import style0 from "./invite-earn-tnc.vue?vue&type=style&index=0&id=7fd04841&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd04841",
  null
  
)

export default component.exports